import { render, staticRenderFns } from "./DiagnosisStages.vue?vue&type=template&id=475d3cf7&scoped=true&"
import script from "./DiagnosisStages.vue?vue&type=script&lang=js&"
export * from "./DiagnosisStages.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosisStages.vue?vue&type=style&index=0&id=475d3cf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475d3cf7",
  null
  
)

export default component.exports